export default "__VITE_ASSET__CC03dJ9G__"